import React from 'react';
import { Slide } from '../../components/deck/Slide';
import { Eyebrow, INK, Label, Reveal, Title } from '../../components/deck/Type';
const SERIF = {
  fontFamily: 'var(--font-serif)'
} as const;
const horizons = [{
  when: 'Today',
  name: 'Diligence',
  tone: INK.blue
}, {
  when: 'Next',
  name: 'Firm intelligence',
  tone: INK.violet
}, {
  when: 'Long term',
  name: 'Private market intelligence infrastructure',
  tone: INK.emerald
}];
const moat = ['Proprietary data', 'Institutional memory', 'Specialized models', 'Industry workflows', 'Customer feedback', 'Curated data infrastructure'];
export function VisionSlide() {
  return <Slide variant="deep" data-id="element-445" data-mp="1wqmiz89k458l">
      <Eyebrow data-id="element-446" data-mp="21pzcucyuicko">Vision</Eyebrow>
      <Title className="mt-[2.2cqh] max-w-[70%]" data-id="element-447" data-mp="21p63r5cezazd">Building the Intelligence Infrastructure for Private Markets.</Title>

      <div className="mt-auto grid grid-cols-[1fr_36%] gap-[4cqw]" data-id="element-448" data-mp="2pes43w4ivw8y">
        <div className="flex flex-col" data-id="element-449" data-mp="2u6sao7f3lnei">
          {horizons.map((h, i) => <React.Fragment key={h.name} data-id="element-450" data-mp="30h8nv7jtol0y" data-mpi={i}>
              {i > 0 && <span className="py-[1cqh] pl-[1.6cqw] text-[1.2cqw] text-white/30" aria-hidden data-id="element-451" data-mp="30higz405z8av">
                  ↓
                </span>}
              <Reveal delay={0.08 * i} className="flex items-baseline gap-[2cqw] border border-white/10 bg-white/[0.025] px-[1.6cqw] py-[2.4cqh]" data-id="element-452" data-mp="3a7bnhqlg8x89">
                <span className="w-[8cqw] shrink-0" data-id="element-453" data-mp="3k46iw0mfehib">
                  <Label tone={h.tone} data-id="element-454" data-mp="3f654vu3ux8dp">{h.when}</Label>
                </span>
                <span className="leading-none text-[#F4F7FC]" style={{
              ...SERIF,
              fontSize: `${2 + i * 0.25}cqw`
            }} data-id="element-455" data-mp="3f895o36glr9r">
                  {h.name}
                </span>
              </Reveal>
            </React.Fragment>)}
        </div>

        <div data-id="element-456" data-mp="1yrdbbduz5v2t">
          <Label tone={INK.gold} data-id="element-457" data-mp="1ysy4p05jz7z3">The moat</Label>
          <ul className="mt-[1.8cqh]" data-id="element-458" data-mp="1ytq1geavzbqy">
            {moat.map(m => <li key={m} className="border-b border-white/8 py-[1.5cqh] text-[1.15cqw] text-[#E3E8F1]" data-id="element-459" data-mp="1tud4v1u7qqb6">
                {m}
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mt-[3.4cqh] flex items-center gap-[1.4cqw] border-t border-white/12 pt-[2.2cqh]" data-id="element-460" data-mp="2pa71125nrqv">
        <span className="h-px w-[2.4cqw] bg-[#D8A55A]" aria-hidden data-id="element-461" data-mp="7ma4wooupo6w" />
        <p className="text-[1.6cqw] leading-tight text-[#F4F7FC]" style={SERIF} data-id="element-462" data-mp="bporxzb7j4tu">
          As foundation models improve, DiligenceGPT™ becomes more capable — not obsolete.
        </p>
      </div>
    </Slide>;
}